import { render, staticRenderFns } from "./EditorialRanking.vue?vue&type=template&id=30ea564b&scoped=true&"
import script from "./EditorialRanking.vue?vue&type=script&lang=js&"
export * from "./EditorialRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ea564b",
  null
  
)

export default component.exports